
import { Component, Vue, Watch } from "vue-property-decorator";
import Scan2 from "@/views/components/Scan/Scan2.vue";
import DeviceItems2 from "@/views/components/DeviceStatus/DeviceItems2.vue";
import RankingList2 from "@/views/components/RankingList/RankingList2.vue";
import TableHeader from "./TableHeader.vue";
import TableHeaderConfig from "./config";
import { DeviceItems2Module } from "@/store/modules/store_deviceitems2";
import { ScanforAcceptPacketGetOnModule } from "@/store/modules/store_scanforacceptpacketgeton";

import {
  DestinationOrgcodename,
  PdaUsercodename,
  Scan,
  StatisticalData,
  YtoTable,
  LineListcodename,
} from "@/views/components";
import { LogHelper } from "@/common/LogHelper";

import Form2 from "./Form2.vue";
import {
  playFailSound,
  playSuccessSound,
  playWantedPackSound,
  playWarnSound,
} from "@/common/voiceTip";
import {
  checkCode,
  checkCodesAndType,
  getCQInfoByCode,
  modeNew,
  abnormalMovingPartDataUpload,
  collectOnly,
  getOrgCodeListByPage,
  queryCustomerInfo,
  takingTruckUpload,
  cloudPress,
  getLineListByPage,
} from "@/api/service";
import {
  ModeAddType,
  ApiQueryType,
  OpCodeEnum,
  UploadStateEnum,
  ModeType,
  ScanSysType,
  SendDataType,
  ReceiveDataType,
  ErrorCode,
} from "@/common/glboalconstant";
import { playLayerVioce, FloorVoiceInit } from "@/common/voiceLayer";

import dayjs from "dayjs";
import { CarContainerStatus } from "@/api/serviceHelper";
import { parseTime } from "@/utils";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";
import { InterceptUtils } from "@/common/intercept-utils";
import { BizUtil } from "@/utils/biz-util";
@Component({
  name: "scanforacceptpacketgeton",
  components: {
    RankingList2,
    DeviceItems2,
    Scan2,
    StatisticalData,
    Form2,
    TableHeader,
    YtoTable,
    DestinationOrgcodename,
    PdaUsercodename,
    LineListcodename,
  },
})
export default class extends Vue {
  public aaaaa() {
    //  let data = JSON.parse();
    let aaa = this.inputModel.input_scancode;
    let _package: any = {
      DataType: "2",
      code: aaa,
      height: "0.00",
      width: "0.00",
      length: "0.00",
      // weight = textGetWeight.Text,
      mac: this.globalConfig.LocalMac,
    };
    this.setPackageData(_package);
  }
  private config = TableHeaderConfig;
  private statisticalList = [];
  private stAcceptPacketReturnData: any = {
    respcode: "",
    respMessage: "",
    data: {
      busiData: {
        customerName: "",
        customerId: "",
        employeeName: "",
        employeeId: "",
        desOrgCode: "",
        desOrgName: "",
        daTouBi: "",
        extend1: "",
        extend2: "",
        extend3: "",
      },
    },
  };
  public m_iScanSystem = -1;
  public globalConfig: any = {};
  public systemConfig: any = {};
  public loginData: any = {};
  private linePrefixRuleIds = [
    "ENT",
    "LTL",
    "FLT",
    "MOT",
    "OTH",
    "WAC",
    "RAL",
    "TPL",
    "RAL",
    "BUS",
    "TFS",
  ]; //合法的线路号前缀集合
  private nMode = 0;
  private m_bFirstGet = true;
  private m_bNoNesseryMsg = false; //缺少必要信息
  private m_bNeedSuppleCode = false; //是否需要补码

  mounted() {
    //初始化声音分层路径
    FloorVoiceInit();
    //初始化统计数据栏目内显示的数据
    this.statisticalList = [
      { label: "总扫描数", value: "0", combine: "1" },
      { label: "车内件数", value: "0", combine: "2" },
      { label: "累计重量", value: "0", combine: "3" },
    ];

    try {
      //注册回调：从Dws获取数据，客户端需注册
      if (typeof obj_DWS_Core !== "undefined") {
        obj_DWS_Core.registerJavaScriptCallback(
          "DWSReceiveDataSetPackageData",
          (value) => {
            console.log("DWS传输过来的参数");
            console.log(value);
            this.ReceiveDataEvent(JSON.parse(value));
          }
        );
      }
      //注册回调：从相机获取数据，客户端需注册
      if (typeof obj_CodeReader_Core !== "undefined") {
        obj_CodeReader_Core.registerJavaScriptCallback(
          "CodeReaderSetPackageData",
          (value) => {
            console.log(
              dayjs().format("YYYY-MM-DD HH:mm:ss SSS") + "得到快手条码"
            );
            let data = JSON.parse(value);
            let _package: any = {
              DataType: "2",
              code: data.CodeInfo,
              height: "0.00",
              width: "0.00",
              length: "0.00",
              // weight = textGetWeight.Text,
              mac: this.globalConfig.LocalMac,
            };
            this.setPackageData(_package);
          }
        );
      }
    } catch (error) {
      console.log("error:" + "注册回调函数异常" + error);
    }

    //获取全局信息
    this.globalConfig = SystemConfigModule.globalData;
    this.systemConfig = SystemConfigModule.systemData;
    this.loginData = SystemConfigModule.loginData;
    //获取全局信息结束

    //把光标聚焦在输入框
    var el = document.getElementById("input_scancode_id");
    this.selectElementContents(el);
    //获取参数
    this.m_iScanSystem = this.systemConfig.ModeInfo.Mode_Type;
    //获取模式
    this.nCurrentMode = this.systemConfig.ModeInfo.ModeAdd_Type;

    this.nMode = this.systemConfig.ModeInfo.Mode_Type;
    if (this.nMode > ModeType.ManualScanOutputType) {
      this.nMode = 2;
    }

    //获取交叉带限重
    if (null != this.globalConfig.ClientConfigData) {
      for (
        let index = 0;
        index < this.globalConfig.ClientConfigData.length;
        index++
      ) {
        if (
          this.globalConfig.ClientConfigData[index].Key ==
          "maxWeightForCrossBelt"
        ) {
          this.maxWeightForCrossBelt = Number.parseFloat(
            this.globalConfig.ClientConfigData[index].Value
          );

          LogHelper.WriteLog(
            "三段码网关配置允许交叉带最大重量为：" +
              this.maxWeightForCrossBelt.toString()
          );
          console.log(
            "三段码网关配置允许交叉带最大重量为：" +
              this.maxWeightForCrossBelt.toString()
          );
          break;
        }
      }
    } else {
      LogHelper.WriteLog("Global.GlobalConfig.***获取重量结束 为null");
    }

    //初始化串口
    this.SerialPortInit();

    //校验是否圆通有效相机
    if (!this.globalConfig.DeviceStatusValid) {
      this.$message.error("非圆通有效相机");
    }

    if (!this.globalConfig.MonitorLoginStatus) {
      this.$message.error("OSD连接失败");
    } else {
      this.$message.success("OSD连接成功");
    }
    try {
      setTimeout(() => {
        obj_ScanForAcceptPacketGetOn.vueLoaded(); //告诉客户端，前端界面已经初始化完成。可以开始加载后续摄像头绑定之类的事件
      }, 0.5 * 1000);
    } catch (error) {
      console.log("揽发合一界面加载完成调用失败" + error);
    }
  }

  beforeDestory() {
  }
  //如果选择了附加项为3 那么就会根据配置初始化串口
  private SerialPortInit() {
    try {
      //#region add by 顾杨 2021年8月16日13:14:47

      LogHelper.WriteLog("当前附加项为：" + this.nCurrentMode.toString());
      if (BizUtil.isControlWeight(this.nCurrentMode)) {
        try {
          let strBaudRate = this.systemConfig.ModeInfo.RollWeightBaudrate;
          let strDateBits = "8";
          let iBaudRate = Number.parseInt(strBaudRate);
          let iDateBits = Number.parseInt(strDateBits);

          let serialPortOpenFlag = obj_SerialPort_Core.isOpen();
          if (!serialPortOpenFlag) {
            let initResult = obj_SerialPort_Core.init(
              this.systemConfig.ModeInfo.RollWeightCom, //串口号
              iBaudRate, //波特率
              iDateBits, //数据位
              1, //停止位
              0 //校验位
            );
            if (initResult) {
              let openResult = obj_SerialPort_Core.open();
              if (!openResult) {
                this.bIsRollInit = false;
                LogHelper.WriteLog("初始化皮带秤失败！");
              } else {
                //串口打开成功，开始添加定时器，监控传过来的参数
                this.bIsRollInit = true;
                LogHelper.WriteLog("初始化皮带秤成功！");
              }
            } else {
              LogHelper.WriteLog("串口初始化失败");
            }
          } else {
            this.bIsRollInit = true;
            LogHelper.WriteLog("皮带秤串口已打开，连接成功！");
          }

        } catch (ex) {
          LogHelper.WriteLog("初始化皮带秤失败！" + ex);
        }
      }
      //#endregion
    } catch (error) {}
  }
  //处理DWS数据
  private ReceiveDataEvent(receiveDataEventArgs) {
    switch (receiveDataEventArgs.ReceiveDataType) {
      case ReceiveDataType.CameraState:
        this.SetCameraState(
          JSON.parse(receiveDataEventArgs.JsonData.toString())
        );
        break;
      case ReceiveDataType.PackageData:
        LogHelper.WriteLog("收到底层数据:" + receiveDataEventArgs.JsonData);
        this.setPackageData(
          JSON.parse(receiveDataEventArgs.JsonData.toString())
        );
        break;
      case ReceiveDataType.CodeCheck:
        LogHelper.WriteLog("收到底层数据:" + receiveDataEventArgs.JsonData);
        if (this.CheckMainData()) {
          this.SetCodeCheckNew(
            JSON.parse(receiveDataEventArgs.JsonData.toString())
          );
        }
        break;
      case ReceiveDataType.ErrorState:
        LogHelper.WriteLog(
          "收到底层错误状态码:" + receiveDataEventArgs.JsonData
        );
        this.SetErrorCode(JSON.parse(receiveDataEventArgs.JsonData.toString()));
        break;
      case ReceiveDataType.ErrorInfo:
        LogHelper.WriteLog("收到底层错误信息:" + receiveDataEventArgs.JsonData);
        this.SetErrorInfo(JSON.parse(receiveDataEventArgs.JsonData.toString()));
        break;
    }
  }
  //DWS错误code处理函数
  public SetErrorCode(IntErrorCode) {
    if (this.m_bNoNesseryMsg) return false;
    switch (Number.parseInt(IntErrorCode.errorCode)) {
      case ErrorCode.NeedSuppleCode:
        this.errormessage = "需要补码";
        this.m_bNeedSuppleCode = true;
        break;
      case ErrorCode.TooMuchCode:
        this.errormessage = "多条码";
        break;
      case ErrorCode.NoWeight:
        this.errormessage = "无重量";
        break;
      case ErrorCode.OverWeight:
        this.errormessage = "超重";
        break;
      case ErrorCode.NoVolumn:
        this.errormessage = "无体积";
        break;
      case ErrorCode.TooLong:
        this.errormessage = "体积超长";
        break;
      case ErrorCode.NoEntry:
        this.errormessage = "超时，包裹不准入";
        break;
      case ErrorCode.ClearState:
        this.errormessage = "";
        break;
      case ErrorCode.Reset:
        this.errormessage = "";
        this.m_bNeedSuppleCode = false;
        break;
      default:
        break;
    }
    return true;
  }
  //DWS错误信息处理函数
  public SetErrorInfo(stErrorInfo) {
    LogHelper.WriteLog(
      "ScanForAcceptPacketGetOn_HKDeviceErrorInfo: " +
        JSON.stringify(stErrorInfo)
    );
    this.errormessage = stErrorInfo.ErrorString;
  }
  //DWS 判断主数据
  public CheckMainData() {
    let carsignnum = this.inputModel.input_CarLabel;
    if (this.IsNullorEmptyorUndefined(carsignnum)) {
      try {
        playFailSound();
      } catch (Exception) {
        this.errormessage = "失败提示音不存在";
      }

      this.m_bNoNesseryMsg = true;
      this.errormessage = "车签不能为空";

      return false;
    }

    let linecodename = this.inputModel.input_PanelLineNow;
    if (linecodename.indexOf("|") == -1 || linecodename.split("|")[0] == "") {
      try {
        playFailSound();
      } catch (Exception) {
        this.errormessage = "失败提示音不存在";
      }

      this.m_bNoNesseryMsg = true;
      this.errormessage = "线路不能为空";

      return false;
    }

    let nextorg = this.inputModel.input_NextOrgNow;
    if (nextorg.indexOf("|") == -1 || nextorg.split("|")[0] == "") {
      try {
        playFailSound();
      } catch (Exception) {
        this.errormessage = "失败提示音不存在";
      }

      this.m_bNoNesseryMsg = true;
      this.errormessage = "下一网点不能为空";

      return false;
    }

    this.m_bNoNesseryMsg = false;
    return true;

  }
  //DWS设置相机状态
  private SetCameraState(strCameraState) {
    //更新设备状态
    debugger;
    let items = this.RefreshState(strCameraState);
    DeviceItems2Module.SetDeviceItemsState(items);
    if (this.m_bFirstGet) {
      this.m_bFirstGet = false;
      //等待200ms后尝试执行
      setTimeout(() => {
        obj_DWS_Core.hKSocketSynSendDataCallBack(
          SendDataType.Watermark,
          this.loginData.orgCode +
            "|" +
            this.loginData.orgName +
            "|310131|揽发合一"
        );
        LogHelper.WriteLog(
          "SendDataType.Watermark:" +
            this.loginData.orgCode +
            "|" +
            this.loginData.orgName +
            "|310131|揽发合一"
        );
      }, 0.2 * 1000);
    }

    return;
  }
  //DWS刷新设备状态信息
  private RefreshState(camera_State) {
    let result = [];
    for (let i = 1; i <= camera_State.cameraState.camList.length; i++) {
      let _info =
        "" +
        "设备" +
        i.toString() +
        "-" +
        "设备状态:" +
        camera_State.cameraState.camList[i - 1].camStatus +
        "-" +
        "设备模式:" +
        this.IsNullorEmptyorUndefined(
          camera_State.cameraState.camList[i - 1].camModel
        )
          ? ""
          : camera_State.cameraState.camList[i - 1].camModel +
            "-" +
            //$"是否有值:是-" +
            "设备Mac:" +
            camera_State.cameraState.camList[i - 1].camMac;

      result.push({
        title: _info,
        name: "设备" + i,
        status:
          camera_State.cameraState.camList[i - 1].camStatus == "1"
            ? "true"
            : "false",
      });
    }

    return result;
  }

  //快手逻辑
  private setPackageData(stPackageData) {
    try {
      debugger;

      LogHelper.WriteLog(
        "【揽发合一】:摄像头触发扫码，条码为{stPackageData.code}"
      );
      this.errormessage = "";
      if (this.nCollectAndGetOnFailCount >= 5) {
        this.errormessage = "揽发合一数据异常，请重启软件或现场IT !";
        return false;
      }

      // var hasCodeTask = Task.Factory.StartNew(() =>
      // {
      //     return m_OutBound_GetOff_DataList.Where(t => t.strCode == stPackageData.code).Any();
      // });

      stPackageData.code = stPackageData.code.toUpperCase().trim();
      var rg = JSON.parse(checkCodesAndType(stPackageData.code.split(), "310"));
      if (rg.ResultCode != 200) {
        this.errormessage = rg.Info;
        this.NewAbnormalMovingPartUpload(
          stPackageData.code,
          rg.Info,
          null,
          "100"
        );
        return false;
      }

      //如果扫描到车签
      if (rg.ResultCode == "200" && rg.Type == ApiQueryType.strCarCode) {
        LogHelper.WriteLog("【揽发合一】:扫描到车签");
        let requestGetCQInfoByCode = {
          devType: "0",
          devMac: this.globalConfig.LocalMac,
          body: {
            viewType: "1",
            queryValue: stPackageData.code,
            queryType: "17",
          },
        };
        var response = JSON.parse(
          getCQInfoByCode(JSON.stringify(requestGetCQInfoByCode))
        );
        if (response == null || response.isSuccess == false) {
          LogHelper.WriteLog(
            "车签查询失败, 错误信息:" +
              response?.respMessage +
              "，错误代码：" +
              response?.respcode
          );
          return false;
        }

        this.inputModel.input_CarLabel = stPackageData.code;
        this.panel_line_ValueChanged(
          response.data == null ||
            this.IsNullorEmptyorUndefined(response.data.lineCode)
            ? ""
            : response.data.lineCode,
          ""
        );

        try {
          playSuccessSound();
          // ToolsPlayVoice.CreateSingleInstance().PlayAsycSound(strOperSuccessVoice);
        } catch (Exception) {
          this.errormessage = "成功提示音不存在";
        }
        // callbackdic["scanareacallback"]?.ExecuteAsync(SCANOBJECT);
        return false;
      } else {
        // this.inputModel.input_scancode = stPackageData.code;
        this.inputModel.input_scancode = "";
        // callbackdic["scanareacallback"]?.ExecuteAsync(SCANOBJECT);
      }

      //                #region  判断主数据
      let carsignnum = this.inputModel.input_CarLabel;
      if (this.IsNullorEmptyorUndefined(carsignnum)) {
        try {
          playFailSound();
        } catch (Exception) {
          //callbackdic["errormsgcallback"]?.ExecuteAsync("失败提示音不存在");
        }

        this.m_bNoNesseryMsg = true;
        this.errormessage = "车签不能为空";

        return false;
      }

      let linecodename = this.inputModel.input_PanelLineNow;
      if (linecodename.indexOf("|") == -1 || linecodename.split("|")[0] == "") {
        try {
          playFailSound();
        } catch (Exception) {}

        this.m_bNoNesseryMsg = true;
        this.errormessage = "线路不能为空";

        return false;
      }

      let nextorg = this.inputModel.input_NextOrgNow;
      if (nextorg.indexOf("|") == -1 || nextorg.split("|")[0] == "") {
        try {
          playFailSound();
        } catch (Exception) {}

        this.m_bNoNesseryMsg = true;
        this.errormessage = "下一网点不能为空";

        return false;
      }
      this.m_bNoNesseryMsg = false;

      let weight = 0.0;

      if (
        this.globalConfig.CurrentDeviceType != 2 &&
        this.globalConfig.CurrentDeviceType != 7
      ) {
        if (this.globalConfig.WeighConfig.On) {
          weight = obj_Weight_Core.getWeight(stPackageData.code);
          if (weight <= 0) {
            LogHelper.WriteLog("读取串口数据小于等于0:" + weight.toString());
          }
        } else {
          weight = Number.parseFloat(stPackageData.weight);
        }
      } else {
        weight = Number.parseFloat(stPackageData.weight);
      }

      if (weight < 0) {
        this.errormessage = "当前重量无效：" + weight;
        LogHelper.WriteLog("当前重量无效：" + weight.toString());
        weight = 0;
        LogHelper.WriteLog("输入重已覆盖成:" + weight.toString());
      }
      this.inputModel.input_weighweight = weight.toString();
      LogHelper.WriteLog("***获取重量结束" + weight);

      // #region 称入重和输入重为0判断
      let _weight = 0.0;
      let _putinweight = 0.0;

      try {
        _weight = Number.parseFloat(
          this.inputModel.input_weighweight.toString()
        );
        if (_weight < 0) {
          LogHelper.WriteLog(
            "上传前检查称入重" + weight.toString() + "，小于0已覆盖成0"
          );
          _weight = 0;
        }
      } catch (error) {
        this.errormessage =
          "称入重数据异常：" +
          this.inputModel.input_weighweight +
          "，请检查数据";
      }

      try {
        _putinweight = Number.parseFloat(
          this.inputModel.input_putinweight.toString()
        );
        if (_putinweight < 0) {
          LogHelper.WriteLog(
            "上传前检查输入重" + _putinweight.toString() + "，小于0已覆盖成0"
          );
          _putinweight = 0;
        }
      } catch (error) {
        _putinweight = 0.0;
        this.errormessage =
          "输入重数据异常" + this.inputModel.input_putinweight + "，请检查数据";
      }

      if (_weight == 0 && _putinweight == 0) {
        this.errormessage = "称入重和输入重均为0，请检查数据";
        return false;
      }
      //#endregion

      // let check_IsNeedVoice = this.inputModel.checked_voice;
      let check_IsNeedVoice = ScanforAcceptPacketGetOnModule.checked_voice;
      //需要声音分层或者选择交叉带时判断重量
      if (check_IsNeedVoice || this.nCurrentMode == 1) {
        if (
          -1 != this.maxWeightForCrossBelt &&
          weight > this.maxWeightForCrossBelt
        ) {
          this.errormessage =
            "当前重量" +
            weight +
            "大于" +
            this.maxWeightForCrossBelt.toString() +
            "公斤，禁止上件";
          LogHelper.WriteLog(
            "当前重量" +
              weight +
              "大于" +
              this.maxWeightForCrossBelt.toString() +
              "公斤，禁止上件"
          );
          return false;
        }
      }
      //如果是DWS时此处不调用三段码接口
      if (
        this.globalConfig.CurrentDeviceType != 2 &&
        this.globalConfig.CurrentDeviceType != 7
      ) {
        if (
          !this.SetCodeCheckNew({ code: stPackageData.code }, weight.toString())
        ) {
          return false;
        }
      }
      //通缉件、退回件优先级最高，为1；无隔口优先级其次，为2；
      if (this.m_nTemp != 1 && this.m_nTemp != 2) {
        LogHelper.WriteLog("通缉件或者无格口件" + this.m_nTemp);
        // callbackdic["errormsgcallback"]?.ExecuteAsync("");
        this.errormessage = "";
        this.m_nTemp = 0;
      }

      //为通缉件和目的网点禁止件时不做下车
      if (this.m_strValidState == "2" && this.m_nTemp == 1) {
        // PlayFailSound();
        playFailSound();
        return false;
      }

      //                 else
      {
        this.inputModel.input_weighweight = Number.parseFloat(weight.toString())
          .toFixed(2)
          .toString();
        this.inputModel.input_TrueThingCode = stPackageData.code;
        stPackageData.weight = Number.parseFloat(weight.toString())
          .toFixed(2)
          .toString();

        this.FacadeEnqueue(stPackageData);
      }

      //如果是驱动皮带秤走的大件快手,添加
      if (
        BizUtil.isControlWeight(this.systemConfig.ModeInfo.ModeAdd_Type) &&
        this.bIsRollInit
      ) {
        try {
          //byte[] sendData = {0x08, 0x06, 0x00, 0x02, 0x00, 0x02, 0x01, 0x00, 0xfe, 0x3d, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00 };
          let strCmd = this.systemConfig.ModeInfo.RollCtlCmd;
          obj_SerialPort_Core.hexWrite(strCmd);
        } catch (ex) {
          LogHelper.WriteLog("【滚筒称】写入串口失败" + ex);
        }
      }

      return true;
    } catch (ex) {
      LogHelper.WriteLog("【揽发合一】:出现问题：" + ex);
      return false;
    }
  }
  public maxWeightForCrossBelt = -1; //交叉带限重
  private bIsRollInit = false; //串口是否打开

  //统计数据
  private dWholeWeight = 0.0; //总重量
  private nTotalScanNum = 0; //总扫描数量
  private PackageNumInCar = 0; //车内件数

  //线路查询
  private linecodenamepagination = 100;
  private linecodenameform = {
    linecodename: "",
  };
  private tableDatalinecodename = [];

  private destinationorgcodenameform = {
    destinationorgcodename: "",
  };

  private showList = [
  ];
  private inputModel: inputDataModel_AcceptPacketGetOn = {
    input_scancode: "",
    input_CarLabel: "",
    input_TrueThingCode: "",
    input_PanelLine: "",
    input_PanelLineNow: "",
    input_NextOrg: "",
    input_NextOrgNow: "",
    input_DestinationOrg: "",
    input_DestinationOrgNow: "",
    input_Person: "",
    input_PersonNow: "",
    input_Custom: "",
    input_CustomNow: "",
    input_weighweight: "0.0",
    input_putinweight: "0.0",
    input_DestinationOrgdisable: false,
    input_Persondisable: false,
    input_Customdisable: false,
    checked_DestinationOrgNow: false,
    checked_PersonNow: false,
    checked_CustomNow: false,
    checked_putinweight: false,
    checked_getorderdestnationorg: true,
    checked_voice: false,
    totalscancount: 0,
    piecescountincar: 0,
    totalweight: 0,
    position: "下车口1",
    list_DestinationOrg: [],
    putinweightdisable: false,
  };
  private options_NextOrg = [
    {
      value: "",
      label: "",
    },
  ];
  private errormessage = "";
  private currentRow = null;

  private pdauserdialogshow = false;
  private pdausercodenameFunc(pdauserModel) {
    this.pdauserdialogshow = false;

    if (this.inputModel.checked_PersonNow == false) {
      this.inputModel.input_Person = pdauserModel.userCode;
      this.inputModel.input_PersonNow =
        pdauserModel.userCode + "|" + pdauserModel.userName;
    } else {
      this.messageboxShow("warning", "收派员已被锁定，请先解锁");
    }
  }
  public findpdausercodename() {
    this.pdauserdialogshow = true;
  }

  private destinationorgdialogshow = false;
  private finddestinationorgcodename() {
    this.destinationorgdialogshow = true;
  }
  private destinationorgcodenameFunc(destinationorgModel) {
    this.destinationorgdialogshow = false;
    if (this.inputModel.checked_DestinationOrgNow == false) {
      this.inputModel.input_DestinationOrg = destinationorgModel.code;
      this.inputModel.input_DestinationOrgNow =
        destinationorgModel.code + "|" + destinationorgModel.name;
    } else {
      this.messageboxShow("warning", "目的网点已被锁定，请先解锁");
    }

    this.destinationorgcodenameform.destinationorgcodename = "";
  }

  private linelistdialogshow = false;
  private linelistcodenameFunc(linelistModel) {
    debugger;
    this.linelistdialogshow = false;

    this.inputModel.input_PanelLine = linelistModel.lineNo;
    this.inputModel.input_PanelLineNow =
      linelistModel.lineNo +
      "|" +
      linelistModel.transType +
      "|" +
      linelistModel.lineName;
    this.getNextOrg(linelistModel.lineNo, linelistModel.lineName);
    this.linecodenameform.linecodename = "";
  }
  //获取下一网点
  public getNextOrg(id, content) {
    debugger;
    try {
      if (this.IsNullorEmptyorUndefined(id)) {
        return;
      }
      let bReturnState = true;
      let stReturnData: any = {};

      let stCodeCheckInput = {
        devMac: this.globalConfig.LocalMac,
        devType: "0",
        body: {
          queryValue: id.toUpperCase(),
          queryType: "0",
          viewType: "1",
          extend1: "",
          extend2: "",
          extend3: "",
        },
      };

      if (!this.NativeCheck(id)) {
        this.errormessage = "输入号码非法";
        return;
      }

      //先本地
      stReturnData = JSON.parse(checkCode(JSON.stringify(stCodeCheckInput)));

      this.errormessage = stReturnData.respMessage;

      if (stReturnData.respcode != "000") {
        bReturnState = false;
        if (stReturnData.respMessage == "") {
          this.errormessage = "服务器掉线";
        }
        this.errormessage = stReturnData.respMessage;

      } else {
        if (stReturnData.data.queryNoType == ApiQueryType.strLineCode) {
          let job = {
            devMac: "00-00-00-00-00-00",
            devType: "0",
            body: {
              queryValue: id, //过滤字符串
              queryType: "21",
              viewType: "1",
              extend1: "", //当前页
              extend2: "", //页大小
              extend3: "", //过滤字段
            },
          };
          var result = getOrgCodeListByPage(JSON.stringify(job));
          if (result != null) {
            try {
              let objectModels = [];
              let _list = [];

              let _job = JSON.parse(result).data;
              let jArray = _job.busiDataArray;
              debugger;
              jArray.forEach((v) => {
                debugger;
                objectModels.push({
                  label: v.endOrgCode,
                  value: v.endOrgName,
                });
                _list.push({
                  label: v.endOrgName,
                  value: v.endOrgCode,
                });
              });
              this.options_NextOrg = _list;
            } catch (error) {
              LogHelper.Error(error);
            }
          }

          stCodeCheckInput.body.queryType = "1";
          this.errormessage = stReturnData.respMessage;
          if (this.options_NextOrg.length > 0) {
            this.inputModel.input_NextOrgNow =
              this.options_NextOrg[this.options_NextOrg.length - 1].value +
              "|" +
              this.options_NextOrg[this.options_NextOrg.length - 1].label;
            this.inputModel.input_NextOrg =
              this.options_NextOrg[this.options_NextOrg.length - 1].label;
          } else {
            this.inputModel.input_NextOrgNow = "";
            this.inputModel.input_NextOrg = "";
          }
        }
      }

      if (bReturnState) {
        this.inputModel.input_scancode = "";
      }
    } catch (ex) {
      LogHelper.WriteLog("【揽发合一】获取下一网点：" + ex);
    }
  }

  private GetLineInfo(lineId) {
    debugger;
    let request = {
      devMac: "00-00-00-00-00-00",
      devType: "0",
      body: {
        queryValue: lineId,
        queryType: "16",
        viewType: "1",
        extend1: "1",
        extend2: "10",
        extend3: "",
      },
    };

    let response = JSON.parse(getLineListByPage(JSON.stringify(request)));
    if (
      response != null &&
      response.respcode == "000" &&
      response.data.busiData.records.length > 0
    ) {
      this.inputModel.input_PanelLineNow =
        response.data.busiData.records[0].lineNo +
        "|" +
        response.data.busiData.records[0].lineName;
      this.inputModel.input_PanelLine =
        response.data.busiData.records[0].lineNo;
    } else {
      this.errormessage = "未查询到线路名称";
      this.inputModel.input_PanelLineNow = "";
      this.inputModel.input_PanelLine = "";
    }
  }

  public findlinecodename() {
    debugger;
    this.linelistdialogshow = true;
    let body = {
      queryValue: "", //网点
      queryType: "16",
      viewType: "1",
      extend1: "1", //当前页
      extend2: "10", //页大小
      extend3: "", //过滤字段
    };
    let job = {
      devMac: "00-00-00-00-00-00",
      devType: "0",
      body: body,
    };
    let response = getLineListByPage(JSON.stringify(job));
    this.initlinedata(response);
  }

  //初始化线路
  private initlinedata(datas): void {
    var jsonobj = JSON.parse(datas);

    if (jsonobj.respcode == "000") {
      var alllinedata = jsonobj.data.busiData.records;
      this.tableDatalinecodename = alllinedata;
      this.linecodenamepagination = jsonobj.data.busiData.total;
    } else {
      console.log(jsonobj);
    }
  }

  private clearlinecodename() {
    this.inputModel.input_PanelLine = "";
    this.inputModel.input_PanelLineNow = "";
  }

  private putinweightnumberfunc(str) {
    try {
      if (isNaN(str)) {
        this.errormessage = "输入重数字输入错误，请重新输入";
        this.inputModel.input_putinweight = String(0);
        return;
      } else {
        var number = Number(str);
        this.inputModel.input_putinweight = String(number);
        this.errormessage = "";
      }
    } catch (error) {
      this.errormessage = "输入重数字输入错误，请重新输入";
    }
  }

  private handleCurrentChange(val) {
    this.currentRow = val;
  }

  //输入重界面锁定方法
  private putinweightFunc() {
    if (this.inputModel.checked_putinweight == true) {
      this.inputModel.putinweightdisable = true;
    } else {
      this.inputModel.putinweightdisable = false;
    }
  }

  private DestinationNowcheckFunc() {
    if (this.inputModel.input_DestinationOrgNow == "") {
      this.errormessage = "当前目的网点为空，锁定无效";
      this.inputModel.checked_DestinationOrgNow = false;
    } else {
      if (this.inputModel.checked_DestinationOrgNow == true) {
        this.$confirm("锁定后目的地为同一个代码，锁定需谨慎！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.inputModel.input_DestinationOrgdisable = true;
          })
          .catch(() => {
            this.inputModel.checked_DestinationOrgNow = false;
          });
      } else {
        this.inputModel.input_DestinationOrgdisable = false;
      }
    }
  }

  private PersonNowcheckFunc() {
    if (this.inputModel.checked_PersonNow == true) {
      this.inputModel.input_Persondisable = true;
    } else {
      this.inputModel.input_Persondisable = false;
    }
  }
  //寄件客户界面框 触发寄件客户输入框置灰
  private CustomNowLock() {
    if (this.inputModel.checked_CustomNow == true) {
      this.inputModel.input_Customdisable = true;
    } else {
      this.inputModel.input_Customdisable = false;
    }
  }

  //显示信息栏
  public messageboxShow(type, msg): void {
    this.$message({
      message: msg,
      type: type,
    });
  }

  //寄件客户查询
  private CheckSendCustomer(sendcustomernum) {
    let bReturnState = true;
    let strTempCode = sendcustomernum;
    strTempCode = strTempCode.toUpperCase();
    let stReturnData: any = {};
    let stCodeCheckInput = {
      devMac: this.globalConfig.LocalMac,
      devType: "0",
      body: {
        queryValue: strTempCode,
        queryType: "3",
        viewType: "1",
        extend1: "",
        extend2: "",
        extend3: "",
      },
    };

    let strReturn = "";
    let localOPCode = "";

    stReturnData = JSON.parse(
      queryCustomerInfo(JSON.stringify(stCodeCheckInput))
    );
    if (stReturnData.respcode != "000") {
      try {
      } catch (Exception) {
        this.errormessage = "失败提示音不存在";
      }

      bReturnState = false;
      if (stReturnData.respMessage == null) {
        this.errormessage = "服务器掉线";

        LogHelper.WriteLog("【揽发合一】:" + "服务器掉线");
      } else {
        this.errormessage = stReturnData.respMessage;

        LogHelper.WriteLog("【揽发合一】:" + strReturn);
      }
      return "";
    } else {
      let name = "";
      if (
        stReturnData.data.busiData.customerId == undefined ||
        stReturnData.data.busiData.customerId == null ||
        stReturnData.data.busiData.customerId == ""
      ) {
        name = name + "";
      } else {
        name = name + stReturnData.data.busiData.customerId;
      }
      name = name + "|";
      if (
        stReturnData.data.busiData.customerName == undefined ||
        stReturnData.data.busiData.customerName == null ||
        stReturnData.data.busiData.customerName == ""
      ) {
        name = name + "";
      } else {
        name = name + stReturnData.data.busiData.customerName;
      }
      return name;
    }
  }
  //选择寄件用户
  public checksendcustomernum(): void {
    debugger;
    if (this.inputModel.checked_CustomNow == true) {
      this.messageboxShow("warning", "客户已被锁定，请先解锁");
    } else {
      var sendcustomernum = this.inputModel.input_Custom;
      try {
        let _name = this.CheckSendCustomer(sendcustomernum);
        this.setsendcustomercallback(_name);
      } catch (error) {
        console.log("error:" + "C#选择寄件客户");
      }
    }
  }

  //选择寄件客户回调
  public setsendcustomercallback(name): void {
    this.inputModel.input_CustomNow = name;
  }

  //获得焦点，选中文本
  private getInputFocus(event): void {
    event.currentTarget.select();
  }

  //扫描区扫码动作触发
  private Input_ScanArea_Click(scanCode) {
    debugger;
    scanCode = scanCode.toString();
    this.inputModel.input_scancode = scanCode.toUpperCase();
    try {
      this.ScanAreaClick();
    } catch (error) {}
    var el = document.getElementById("input_scancode_id");
    this.selectElementContents(el);
  }
  //扫码触发
  private ScanAreaClick() {
    LogHelper.WriteLog("揽发合一界面触发扫码动作");
    this.errormessage = "";

    let scanAreaContent = this.inputModel.input_scancode.toUpperCase().trim();
    if (scanAreaContent == "") {
      try {
        playWarnSound();
        this.errormessage = "输入为空";
        return;
      } catch {
        this.errormessage = "输入为空,警告提示音不存在";
        return;
      }
    }

    var reg1 = new RegExp(/^[A-Za-z0-9]+$/);
    if (!reg1.test(scanAreaContent)) {
      this.errormessage = "输入数据非法，只能输入数字和字母";
      return;
    }

    try {
      if (scanAreaContent.length >= 10) {
        let flag = this.LinePreFixRuleCheck(scanAreaContent);

        if (!flag) {
          //大于等于10个字符
          let temps = [];
          temps.push(scanAreaContent);
          let rgStr = checkCodesAndType(temps, "310");
          let rg = JSON.parse(rgStr);

          debugger;
          if (rg.ResultCode == "200") {
            if (rg.Type == ApiQueryType.strCarCode) {
              if (
                scanAreaContent.toString().indexOf("CQ") != -1 &&
                scanAreaContent.toString().length == 20
              ) {
                this.errormessage = "系统生成的车签，不允许人工录入";
                return false;
              }
              let request = {
                devMac: this.globalConfig.LocalMac,
                devType: "0",
                body: {
                  viewType: "1",
                  queryValue: scanAreaContent,
                  queryType: "17",
                },
              };

              let response = JSON.parse(
                getCQInfoByCode(JSON.stringify(request))
              );
              debugger;
              if (response == null || response.isSuccess == false) {
                LogHelper.WriteLog(
                  "车签查询失败, 错误信息:" +
                    response?.respMessage +
                    "，错误代码：" +
                    response?.respcode
                );
                return;
              }

              if (scanAreaContent.startsWith("CQ")) {
                let response = CarContainerStatus(
                  scanAreaContent,
                  this.globalConfig.LocalMac,
                  this.globalConfig.CurrentDeviceType.toString()
                );
                if (response.status != "1") {
                  this.errormessage = response.resMsg;
                  return;
                }
              }
              this.inputModel.input_CarLabel = scanAreaContent;
              this.inputModel.input_scancode = "";
              this.panel_line_ValueChanged(
                response.data == null ||
                  this.IsNullorEmptyorUndefined(response.data.lineCode)
                  ? ""
                  : response.data.lineCode,
                ""
              );
              try {
                playSuccessSound();
              } catch (Exception) {
                //callbackdic["errormsgcallback"]?.ExecuteAsync("成功提示音不存在");
              }
              LogHelper.WriteLog("揽发合一界面扫描到车签,动作结束");
              return;
            }

            let carsignnum = this.inputModel.input_CarLabel;
            if (this.IsNullorEmptyorUndefined(carsignnum)) {
              try {
                playFailSound();
              } catch (Exception) {
                this.errormessage = "失败提示音不存在";
              }

              this.m_bNoNesseryMsg = true;
              this.errormessage = "车签不能为空";

              return;
            }

            let linecodename = this.inputModel.input_PanelLineNow;
            if (
              linecodename.indexOf("|") == -1 ||
              linecodename.split("|")[0] == ""
            ) {
              try {
                playFailSound();
              } catch (Exception) {
                this.errormessage = "失败提示音不存在";
              }

              this.m_bNoNesseryMsg = true;
              this.errormessage = "线路不能为空";

              return;
            }

            let nextorg = this.inputModel.input_NextOrgNow;
            if (nextorg.indexOf("|") == -1 || nextorg.split("|")[0] == "") {
              try {
                playFailSound();
              } catch (Exception) {
                this.errormessage = "失败提示音不存在";
              }

              this.m_bNoNesseryMsg = true;
              this.errormessage = "下一网点不能为空";

              return;
            }

            this.m_bNoNesseryMsg = false;


            if (this.m_bNeedSuppleCode) {
              LogHelper.WriteLog("***************补码");
              this.SetCodeCheckNew({ code: scanAreaContent });
              this.m_bNeedSuppleCode = false;
              this.inputModel.input_scancode = "";

              return;
            }
            if (
              this.m_iScanSystem == ScanSysType.FastHand ||
              this.m_iScanSystem == ScanSysType.ManuScan
            ) {
              let weight = 0.0;
              try {
                weight = this.GetWeight(scanAreaContent);
              } catch (ex) {
                LogHelper.WriteLog("揽发合一取重失败：" + ex);
              }
              if (weight <= 0) {
                LogHelper.WriteLog("揽发合一重量：" + "读串口数据异常");
                LogHelper.WriteLog("揽发合一重量：" + weight.toString());
                weight = 0;
                LogHelper.WriteLog("输入重已覆盖成:" + weight.toString());
              }
              this.inputModel.input_weighweight = weight.toString();
              LogHelper.WriteLog("揽发合一重量：" + weight.toString());
              debugger;
              if (
                !this.SetCodeCheckNew(
                  { code: scanAreaContent },
                  weight.toString()
                )
              ) {
                return;
              }
            } else {
              this.inputModel.input_weighweight = "0";
            }

            //  称入重和输入重为0判断
            let _weight = 0.0;
            let _putinweight = 0.0;

            if (
              !this.TryParseFloat(this.inputModel.input_weighweight.toString())
            ) {
              this.errormessage = "称入重数据异常，请检查数据";
              LogHelper.WriteLog(
                "揽发合一：称入重异常无法转换成数字" +
                  this.inputModel.input_weighweight
              );
              return;
            } else {
              _weight = Number.parseFloat(
                this.inputModel.input_weighweight.toString()
              );
              if (_weight <= 0) {
                _weight = 0;
                LogHelper.WriteLog("揽发合一：称入重异常，已经覆盖为0");
              }
            }

            if (
              !this.TryParseFloat(this.inputModel.input_putinweight.toString())
            ) {
              this.errormessage = "输入重数据异常，请检查数据";
              LogHelper.WriteLog(
                "揽发合一：输入重异常无法转换成数字" +
                  this.inputModel.input_putinweight
              );
              return;
            } else {
              _putinweight = Number.parseFloat(
                this.inputModel.input_putinweight.toString()
              );
            }

            if (_weight <= 0 && _putinweight <= 0) {
              this.errormessage = "称入重和输入重均为0，请检查数据";
              return;
            }
            if (
              this.showList.some(
                (t) =>
                  t.code == scanAreaContent &&
                  t.state != "上传失败" &&
                  t.CarSignNum == this.inputModel.input_CarLabel
              )
            ) {
              playFailSound();
              this.errormessage = "重复扫描";

              return;
            }

            this.inputModel.input_TrueThingCode = scanAreaContent;

            var _package = {
              code: scanAreaContent,
              mac: "",
              weight: this.inputModel.input_weighweight,
              //width = textWidth.Text,
              DataType: "",
            };
            this.FacadeEnqueue(_package);
            return;
          } else {
            LogHelper.WriteLog(
              "输入条码非法，条码：" +
                scanAreaContent +
                "返回条码类型为：" +
                rg.Type
            );
            this.errormessage = rg.Info;
            this.NewAbnormalMovingPartUpload(
              scanAreaContent,
              rg.Info,
              null,
              "100"
            );
            return;
          }
        }
      }
      // else
      {
        //字符小于10个字符
        let stCodeCheckInput = {
          devMac: this.globalConfig.LocalMac,
          devType: "0",
          body: {
            queryValue: scanAreaContent,
            queryType: "0",
            viewType: "1",
            extend1: "",
            extend2: "",
            extend3: "",
          },
        };
        let stReturnData: any = {};
        let strReturn = "";
        //先本地
        let stReturnDataStr = checkCode(JSON.stringify(stCodeCheckInput));
        stReturnData = JSON.parse(stReturnDataStr);
        this.errormessage = stReturnData.respMessage;

        if (stReturnData.respcode != "000") {
          playFailSound();
          //bReturnState = false;
          if (stReturnData.respMessage == null) {
            this.errormessage = "服务器掉线";
            LogHelper.WriteLog("【揽发合一】:" + "服务器掉线");
          } else {
            this.errormessage = stReturnData.respMessage;
            LogHelper.WriteLog("【揽发合一】:" + strReturn);
          }
        } else {
          if (stReturnData.data.queryNoType == ApiQueryType.strStationCode) {
            this.inputModel.input_DestinationOrg = stReturnData.data.queryNo;
            this.inputModel.input_DestinationOrgNow =
              stReturnData.data.queryNo +
              "|" +
              stReturnData.data.nextOrgCodeName;
            playSuccessSound();
          } else if (
            stReturnData.data.queryNoType == ApiQueryType.strLineCode
          ) {
            stCodeCheckInput.body.queryType = "1";

            try {
              playSuccessSound();
            } catch (Exception) {
              this.errormessage = "成功提示音不存在";
            }

            this.panel_line_ValueChanged(
              stReturnData.data.queryNo,
              ""
            );
          }
        }
      }
    } catch (ex) {
      this.errormessage = "出现异常:" + ex;

      LogHelper.WriteLog("【揽发合一】: scanArea_Click()" + ex);
    }
  }
  public TryParseFloat(value) {
    try {
      Number.parseFloat(value);
      return true;
    } catch (error) {
      return false;
    }
  }
  public TryParseInt(value) {
    try {
      Number.parseInt(value);
      return true;
    } catch (error) {
      return false;
    }
  }
  private SetPackageQueueModel(query, bIsBagCode = false) {
    let carsignnum = this.inputModel.input_CarLabel;
    let customcode = "";
    let customname = "";
    let _linecode = "";
    let _lineName = "";
    let _EmployeeId = "";
    let _EmployeeName = "";
    let _DestOrgCode = "";
    let _DestOrgName = "";
    let _NextOrgCode = "";
    let _NextOrgName = "";
    let _putinweight = "0";

    try {
      //寄件客户
      let custom = this.inputModel.input_CustomNow;
      if (custom.indexOf("|") != -1) {
        customcode = custom.split("|")[1];
        customname = custom.split("|")[0];
      }
      //线路
      let linecodea = this.inputModel.input_PanelLineNow?.toString();
      if (
        !this.IsNullorEmptyorUndefined(linecodea) &&
        linecodea.indexOf("|") != -1
      ) {
        let linecodearr = linecodea.split("|");
        _linecode = linecodearr[0];

        _lineName = linecodearr[linecodearr.length - 1];
      }
      //收派员
      let takingemployeecodeandname =
        this.inputModel.input_PersonNow?.toString();
      if (
        !this.IsNullorEmptyorUndefined(takingemployeecodeandname) &&
        takingemployeecodeandname.indexOf("|") != -1
      ) {
        let takingemployeecodeandnamearr = takingemployeecodeandname.split("|");
        _EmployeeId = takingemployeecodeandnamearr[0];
        _EmployeeName = takingemployeecodeandnamearr[1];
      } else {
        _EmployeeId = this.stAcceptPacketReturnData.data.busiData.employeeId;
        _EmployeeName = this.IsNullorEmptyorUndefined(
          this.stAcceptPacketReturnData.data.busiData.employeeName
        )
          ? ""
          : this.stAcceptPacketReturnData.data.busiData.employeeName;
      }

      //目的网点
      let desorgcodea = this.inputModel.input_DestinationOrgNow?.toString();
      if (
        !this.IsNullorEmptyorUndefined(desorgcodea) &&
        desorgcodea.indexOf("|") != -1
      ) {
        let desorgcodearr = desorgcodea.split("|");
        _DestOrgCode = desorgcodearr[0];
        _DestOrgName = desorgcodearr[1];
      } else {
        _DestOrgCode = this.stAcceptPacketReturnData.data.busiData.desOrgCode;
        _DestOrgName = this.stAcceptPacketReturnData.data.busiData.desOrgName;
      }

      //下一网点
      let nextorgcodename = this.inputModel.input_NextOrgNow?.toString();
      if (
        !this.IsNullorEmptyorUndefined(nextorgcodename) &&
        nextorgcodename.indexOf("|") != -1
      ) {
        let nextorgcodenamearr = nextorgcodename.split("|");
        _NextOrgCode = nextorgcodenamearr[0];
        _NextOrgName = nextorgcodenamearr[1];
      }
      //输入重
      let putinweight = this.inputModel.input_putinweight?.toString();
      if (!this.IsNullorEmptyorUndefined(putinweight)) {
        _putinweight = putinweight;
      }
    } catch (ex) {
      LogHelper.WriteLog("【揽发合一】获取界面数据发生异常" + ex);
    }
    let datetimeNow = dayjs().valueOf();
    // let datetimeNow = (DateTime.Now.ToUniversalTime().Ticks - 621355968000000000) / 10000;
    return {
      CarSignNum: carsignnum,
      //cbxFee = query.cbxFee,
      code: query.code,
      DataType: query.DataType,
      //EffectiveTypeCode = query.EffectiveTypeCode,
      height: query.height == null ? "0" : query.height,
      length: query.length == null ? "0" : query.length,
      mac: query.mac,

      //NextWebPoint = query.NextWebPoint,
      //PreviousWebPoint = query.PreviousWebPoint,
      PutinWeight: _putinweight,

      //RecvType = query.RecvType,
      //Str10 = query.Str10,
      //Str9 = query.Str9,
      VolumnWeight: /*query.VolumnWeight*/ 0.0,
      weight: query.weight,
      width: query.width == null ? "0" : query.width,
      createTime: datetimeNow,
      modifyTime: datetimeNow,
      uploadTime: datetimeNow,
      ScanTime: dayjs(),
      //Line = /*panelLineName.Text,*/"",
      //IsPackage = bIsBagCode,
      //optArea = query.optArea,
      UploadStateCode: UploadStateEnum.NotStarted,
      strCustomerId: customcode,
      strCustomerName: customname,
      LineCode: _linecode,
      LineName: _lineName,
      strEmployeeId: _EmployeeId,
      strEmployeeName: _EmployeeName,
      strDestOrgCode: _DestOrgCode,
      strDestOrgName: _DestOrgName,
      NextOrgCode: _NextOrgCode,
      NextOrgName: _NextOrgName,
    };
  }
  private li = 1;
  //插入列表框
  private InsertDataToList(package_DataByQueue) {
    // //  PassOrder?.Invoke(package_DataByQueue.code, Convert.ToDouble(package_DataByQueue.weight));
    obj_JunanService_Core.junanPassOrder(
      package_DataByQueue.code,
      Number.parseFloat(package_DataByQueue.weight)
    );
    //插入datahistory
    debugger;
    package_DataByQueue.index = this.li.toString();
    package_DataByQueue.state = "未上传";
    package_DataByQueue.scanTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
    this.li++;

    this.showList.unshift(package_DataByQueue);
    while (this.showList.length > 50) this.showList.pop();
    return;
  }
  //生成请求对象
  private GetDataUploadRequest(package_Data) {
    debugger;
    try {
      let _sign = "-";
      if (this.inputModel.checked_putinweight) {
        _sign += "1";
      } else {
        _sign += "0";
      }
      if (this.inputModel.checked_DestinationOrgNow) {
        _sign += "1";
      } else {
        _sign += "0";
      }
      if (this.inputModel.checked_PersonNow) {
        _sign += "1";
      } else {
        _sign += "0";
      }
      _sign += "0";
      if (_sign == "-0000") {
        _sign = "";
      }

      let takingTruckUploadRequest = {
        devMac: this.globalConfig.LocalMac, //物理地址中间的分隔符需要为“-”
        devType: this.globalConfig.CurrentDeviceType.toString(),
        body: {
          mac: this.globalConfig.LocalMac,
          aviType: 0,
          trace: 0,
          isFirstTransfer: 1,
          mty: "0240", //默认为0240 与上下车不同
          opRecord: {
            auxOpCode: "NEW",
            auxRouteCode: "0",
            containerNo: package_Data.CarSignNum,
            createOrgCode: this.loginData.orgCode,
            createTerminal: this.globalConfig.LocalIPv4,
            createTime: package_Data.createTime,
            createUserCode: this.loginData.userCode,
            createUserName: this.loginData.userName + _sign,
            desOrgCode: package_Data.strDestOrgCode,
            deviceType: "CV-PC", //默认
            expType: 10,
            expressContentCode: "PKG", //默认为包裹
            feeAmt: "0.0",
            feeFlag: 0,
            frequencyNo: "", //无频次
            inputWeight: this.inputModel.input_putinweight?.toString(),
            ioType: "01", //收发类型 正常
            waybillNo: package_Data.code,
            modifyOrgCode: this.loginData.orgCode,
            modifyTerminal: "",
            modifyTime: package_Data.modifyTime,
            modifyUserCode: "",
            modifyUserName: "",
            nextOrgCode: package_Data.NextOrgCode,
            opCode: "310131", //默认
            orgCode: this.loginData.orgCode,
            uploadTime: package_Data.uploadTime,
            transportTypeCode: "1",
            transferStatus: 0,
            remark: "10020007", //，默认
            sourceOrgCode: this.loginData.orgCode,
            //weighWeight : SCANOBJECT["input_weighweight"]?.ToString(),
            weighWeight: package_Data.weight?.toString(),
            pkgWidth: package_Data.width == null ? "0" : package_Data.width,
            pkgLength: package_Data.length == null ? "0" : package_Data.length,
            pkgHeight: package_Data.height == null ? "0" : package_Data.height,
            volumeWeight:
              package_Data.VolumnWeight == 0
                ? "0"
                : package_Data.VolumnWeight.toString(), //界面已去除
            pkgQty: 1,
            lineNo: package_Data.LineCode,
            previousOrgCode: "",
            routeCode: "",
            opStation: this.globalConfig.CompName, //操作台名称
            osdFlag: this.globalConfig.MonitorLoginStatus ? "1" : "0", //osd标识
            customData: {
              takingEffectiveTime: "C005", //72小时
              takingEmployeeCode: package_Data.strEmployeeId,
              employeeName: package_Data.strEmployeeName,
              takingCustomerCode: package_Data.strCustomerId,
              customerName: package_Data.strCustomerName,
              frequency: "", //以下默认
              inOutDiff: "1",
              lineFrequencyNo: "",
              otFlag: 0,
              refId: "",
              returnPart: "",
              vehiclePlateNo: "",
              extend1: "",
              extend2: "",
              extend3: "",
            },
          },
        },
      };
      return takingTruckUploadRequest;
    } catch (ex) {
      LogHelper.WriteLog(
        "ScanForAcceptPacketGetOn-GetDataUploadRequest-Exception： " + ex
      );
      return {};
    }
  }
  private currentGeKou = ""; //当前格口
  private currentDaTouBi = ""; //当前单号的大头笔
  private FacadeEnqueue(stPackageData) {
    //获取实体
    let package_DataByQueue = this.SetPackageQueueModel(stPackageData);

    try {
      if (obj_Camera_Core.cameraBLLEnqueueFacadeNew != undefined) {
        let resultStr = obj_Camera_Core.cameraBLLEnqueueFacadeNew(
          stPackageData.code,
          OpCodeEnum.collectandabord,
          this.loginData.employeeName,
          package_DataByQueue.strDestOrgCode,
          "揽发合一",
          parseTime(new Date(package_DataByQueue.createTime))
        );
      } else {
        let resultStr = obj_Camera_Core.cameraBLLEnqueueFacade(
          stPackageData.code,
          OpCodeEnum.collectandabord,
          this.loginData.employeeName,
          package_DataByQueue.strDestOrgCode,
          "揽发合一"
        );
      }
    } catch (error) {
      LogHelper.Error("揽收上传OSD异常:" + error.toString());
    }

    let request = this.GetDataUploadRequest(package_DataByQueue);
    let ExpWayBillCheckQueueEntity: any = {
      CallBack: null, //交给C#实现
      Id: null, //交给C#实现
      Request: null,
      WaybillNo: package_DataByQueue.code,
      devType: this.globalConfig.CurrentDeviceType.toString(),
      bIsPackageCode: false,
      latticeNo: this.currentGeKou,
      destOrgCode: package_DataByQueue.strDestOrgCode,
      sourceOrgCode: "",
      OpCode: OpCodeEnum.collectandabord,
      daTouBi: this.currentDaTouBi,
      protocolType: 0, //当前协议类型，1表示供件协议，0表示正常协议，默认为正常协议
    };
    //插入队列
    obj_HttpRequest_Core.enqueueFacade(
      this.DataUploadCallBack,
      JSON.stringify(request),
      // JSON.stringify(package_DataByQueue),
      JSON.stringify(ExpWayBillCheckQueueEntity)
    );

    //package_DataByQueue.RecvType = cbx_recvType.Text;
    //package_DataByQueue.RecvType = "01";//收发类型默认为"01"(正常)
    //插入列表集合，并更新列表控件
    this.InsertDataToList(package_DataByQueue);
    playSuccessSound();

    //更新汇总信息
    this.dWholeWeight += Number.parseFloat(package_DataByQueue.weight);
    this.nTotalScanNum++;
    this.PackageNumInCar++;
    // SCANOBJECT["totalweight"] = String.Format("{0:F}", this.dWholeWeight);
    // SCANOBJECT["totalscancount"] = this.nTotalScanNum.toString();
    // SCANOBJECT["piecescountincar"] = this.PackageNumInCar.toString();

    this.statisticalList[0].value = this.nTotalScanNum.toString();
    this.statisticalList[1].value = this.PackageNumInCar.toString();
    this.statisticalList[2].value = this.dWholeWeight.toString();

    if (!this.inputModel.checked_DestinationOrgNow) {
      this.inputModel.input_DestinationOrg = "";
      this.inputModel.input_DestinationOrgNow = "";
    }
    if (!this.inputModel.checked_PersonNow) {
      this.inputModel.input_Person = "";
      this.inputModel.input_PersonNow = "";
    }
    if (!this.inputModel.checked_CustomNow) {
      this.inputModel.input_Custom = "";
      this.inputModel.input_CustomNow = "";
    }
    if (!this.inputModel.checked_putinweight) {
      this.inputModel.input_putinweight = "0";
    }
    this.inputModel.input_TrueThingCode = "";
    // callbackdic["scanareacallback"]?.ExecuteAsync(SCANOBJECT);
  }
  private nCollectAndGetOnFailCount = 0; //连续上传失败的次数

  //上传后的返回函数
  private DataUploadCallBack(callbackentityStr) {
    debugger;
    let callBackEntity = JSON.parse(callbackentityStr);
    if (callBackEntity == null || callBackEntity.Response == null) {
      return;
    }

    //if (callBackEntity.extend1 == "1")
    //{
    //    PackageNumInCar = 1;
    //}

    if (
      callBackEntity.IsSuccess ||
      (callBackEntity.IsSuccess == false &&
        (callBackEntity.extend1 == "2" || callBackEntity.extend1 == "3"))
    ) {
      this.nCollectAndGetOnFailCount = 0;
    } else {
      var res = JSON.parse(checkCodesAndType(callBackEntity.Request.WaybillNo.split(), "310"));
      if (res.ResultCode == "200" && res.Type == ApiQueryType.strPackageCode)
      {
        this.nCollectAndGetOnFailCount=0;
        this.NewAbnormalMovingPartUpload(callBackEntity.Request.WaybillNo, "非法单号", null, "-801");
      }
      else
      {
        this.nCollectAndGetOnFailCount++;
      }
    }

    //var stReturn = callBackEntity.Response as Return_Common;
    let stReturn = callBackEntity.Response;
    let strCode = callBackEntity.Request.WaybillNo;

    //if (strCode.ToUpper().StartsWith("R02T") || strCode.ToUpper().StartsWith("R02Z"))
    //{
    //    strCode = strCode.ToUpper().Replace("R02T", "").Replace("R02Z", "");
    //}

    LogHelper.WriteLog(
      "揽发合一更新上传状态ScnForAcceptPackteGetOn:" + strCode
    );

    // // var first = DataHistory.FirstOrDefault(x => x.code == strCode);
    // // if (first != null)
    // // {
    // //     //if (!string.IsNullOrEmpty(stReturn?.data?.opRecord?.PDA_NO))
    // //     //{
    // //     //    //first.NextWebPoint = stReturn.data.opRecord.PDA_NO;
    // //     //}
    // //     first.UploadStateCode =
    // //         Convert.ToInt32(callBackEntity.IsSuccess ? UploadStateEnum.Sucess : UploadStateEnum.Fail);
    // //     first.Info = stReturn?.respMessage;
    // // }

    var formfirst = this.showList.filter((x) => x.code == strCode)[0];
    if (formfirst != null) {
      //if (!string.IsNullOrEmpty(stReturn?.data?.opRecord?.PDA_NO))
      //{
      //    //first.NextWebPoint = stReturn.data.opRecord.PDA_NO;
      //}
      // // formfirst.state = first?.UploadStateName;
      // // formfirst.message = first?.Info;
      formfirst.state = callBackEntity.IsSuccess ? "上传成功" : "上传失败";
      formfirst.message = stReturn?.respMessage;
    }

    //this.Invoke(new Action(() => { clearData(); }));
  }
  //取重方法
  private GetWeight(scanContent) {
    try {
      let weight = obj_Weight_Core.getWeight(scanContent);
      // weight = Math.floor(weight * 100) / 100;
      if (typeof weight == 'string'){
        weight = Number.parseFloat(weight).toFixed(2);
      }
      else if (typeof weight == 'number'){
        weight = weight.toFixed(2);
      }
      else{
        console.log('无法处理的重量数据类型：'+typeof weight);
        return 0;
      }
      return weight;
    } catch (error) {
      return 0;
    }
  }
  private IsInterceptCode(code) {
    var res = JSON.parse(checkCodesAndType(code.split(), "310"));
    if (res.ResultCode != "200") {
      this.errormessage = res.Info;
      //上传异常走件
      this.NewAbnormalMovingPartUpload(code, res.Info, null, "100");
      return true;
    } else {
      return false;
    }
  }

  private m_nTemp = 0;
  public nCurrentMode = -1; //当前模式
  private m_strValidState = "";
  public SetCodeCheckNew(codeCheckData, strWeight = "") {
    try {
      this.errormessage = "";

      this.m_nTemp = 0;

      if (this.nCollectAndGetOnFailCount >= 5) {
        this.errormessage = "揽发合一数据异常，请重启软件或现场IT !";
        return false;
      }

      if (this.IsInterceptCode(codeCheckData.code)) {
        if (
          this.globalConfig.CurrentDeviceType == 5 ||
          this.globalConfig.CurrentDeviceType == 7
        ) {
          obj_DWS_Core.hKSocketSynSendDataCallBack(
            SendDataType.PortData,
            codeCheckData.code + "|" + "153"
          );
          return false;
        }
      }

      try {
        //查询三段码接口
        let strTemp = "";
        let destOrgCodeName = this.inputModel.input_DestinationOrgNow;
        if (
          !this.IsNullorEmptyorUndefined(destOrgCodeName) &&
          destOrgCodeName.indexOf("|") != -1
        ) {
          strTemp = destOrgCodeName.split("|")[0];
        } else {
          strTemp = "";
        }
        // let check_IsNeedVoice = this.inputModel.checked_voice;
        let check_IsNeedVoice = ScanforAcceptPacketGetOnModule.checked_voice;

        //if (check_IsNeedVoice.Checked)
        if (check_IsNeedVoice) {
          strTemp += ";1";
        } else {
          strTemp += ";";
        }

        //线路编码
        let _lineNo = "";
        //线路下一网点
        let _lineNextOrgCode = "";
        //线路
        let linecodea = this.inputModel.input_PanelLineNow?.toString();
        if (
          !this.IsNullorEmptyorUndefined(linecodea) &&
          linecodea.indexOf("|") != -1
        ) {
          let linecodearr = linecodea.split("|");
          _lineNo = linecodearr[0];
        }

        let nextorgcodename = this.inputModel.input_NextOrgNow?.toString();
        if (
          !this.IsNullorEmptyorUndefined(nextorgcodename) &&
          nextorgcodename.indexOf("|") != -1
        ) {
          let nextorgcodenamearr = nextorgcodename.split("|");
          _lineNextOrgCode = nextorgcodenamearr[0];
        }

        let request = {
          devMac: this.globalConfig.LocalMac,
          devType: this.globalConfig.CurrentDeviceType.toString(),
          body: {
            autoMode:
              this.nCurrentMode == 0 ? "3" : BizUtil.isControlWeight(this.nCurrentMode) ? "3" : "2",
            wayBillNo: codeCheckData.code,
            mac: this.globalConfig.LocalMacIPv4,
            extend1: strWeight,
            extend2: "",
            extend3: strTemp,
            optFlag: "4",
            destOrgCode: this.inputModel.input_DestinationOrg,
            lineNo: _lineNo,
            nextOrgCode:_lineNextOrgCode
          },
        };

        this.currentDaTouBi = "";
        this.currentGeKou = "";
        // var sw = new System.Diagnostics.Stopwatch();
        // sw.Start();
        let dwsQueryResponseNew = modeNew(JSON.stringify(request));
        // sw.Stop();
        debugger;
        if (dwsQueryResponseNew.respcode != "000") {
          playFailSound();
          this.errormessage = dwsQueryResponseNew.respMessage;
          LogHelper.WriteLog(
            "【揽发合一】三段码接口返回失败：" + dwsQueryResponseNew.respMessage
          );
          return false;
        } else {
          this.currentDaTouBi = this.IsNullorEmptyorUndefined(
            dwsQueryResponseNew?.data.customer_NO
          )
            ? ""
            : dwsQueryResponseNew?.data.customer_NO;
          this.currentGeKou = this.IsNullorEmptyorUndefined(
            dwsQueryResponseNew?.data.lattice_NO
          )
            ? ""
            : dwsQueryResponseNew?.data.lattice_NO;
          //if (GlobalConfig.InterceptorCode.Split(',').Contains(dwsQueryResponseNew.data.DA_TOU_BI))
          if (
            !this.IsNullorEmptyorUndefined(
              dwsQueryResponseNew.data?.da_TOU_BI
            ) &&
            dwsQueryResponseNew.data.da_TOU_BI.substring(0, 1) == "-"
          ) {
            this.m_strValidState = "2";
            let strInfo = "";
            this.errormessage =
              InterceptUtils.formatErrorMessage(codeCheckData.code, dwsQueryResponseNew?.data.da_TOU_BI, dwsQueryResponseNew.respMessage);
            strInfo = dwsQueryResponseNew.respMessage;

            if (
              dwsQueryResponseNew.data?.upload_OPT_FLAG == "1" &&
              dwsQueryResponseNew.data?.upload_ERROR_FLAG != "1"
            ) {
              this.m_strValidState = "1";
            } else {
              if (dwsQueryResponseNew.data?.upload_ERROR_FLAG == "1") {
                // Task.Run(() =>
                // {
                //     AbnormalMovingPartUpload(codeCheckData.code, strInfo, strWeight, dwsQueryResponseNew.data.DA_TOU_BI);
                // });
                this.$nextTick(() => {
                  this.NewAbnormalMovingPartUpload(
                    codeCheckData.code,
                    strInfo,
                    strWeight,
                    dwsQueryResponseNew.data.da_TOU_BI
                  );
                });
              }
              this.m_strValidState = "2";
              this.m_nTemp = 1;
              try {
                if (dwsQueryResponseNew.data.intercept_FLAG == "1") {
                  playWantedPackSound(dwsQueryResponseNew.data.da_TOU_BI);
                } else {
                  playFailSound();
                }
              } catch (Exception) {
              }
            }
          } else {
            this.m_strValidState = "1";
          }

          //如果返回声音分层则报声音分层信息
          if (
            !this.IsNullorEmptyorUndefined(
              dwsQueryResponseNew.data.sound_FLOOR_NO
            )
          ) {
            LogHelper.WriteLog(
              "揽发合一：进入声音分层" + dwsQueryResponseNew.data.sound_FLOOR_NO
            );
            this.errormessage = dwsQueryResponseNew.data.sound_FLOOR_NO + "层";
            playLayerVioce(dwsQueryResponseNew.data.sound_FLOOR_NO);
            console.log(
              dayjs().format("YYYY-MM-DD HH:mm:ss SSS") + "播放声音结束"
            );
            if (typeof VoiceLayerHelper !== "undefined") {
              VoiceLayerHelper.onPlaySoundFloor(
                dwsQueryResponseNew.data.sound_FLOOR_NO
              );
            }
          }

          if (dwsQueryResponseNew.data.extend1 == "1") {
            let bIsDisplsy = false;
            if (
              this.IsNullorEmptyorUndefined(dwsQueryResponseNew.data.lattice_NO)
            ) {
              //此单号为无格口的通缉件时优先显示通缉件
              if (this.m_nTemp != 1) {
                this.m_strValidState = "3";
                this.errormessage =
                  "无格口号 " +
                  dwsQueryResponseNew.data.da_TOU_BI +
                  " " +
                  dwsQueryResponseNew.data.waybill_NO;

                obj_HttpRequest_Core.queueExceptionEnqueue(
                  dwsQueryResponseNew.data.waybill_NO,
                  OpCodeEnum.collectandabord,
                  1,
                  this.globalConfig.CurrentDeviceType.toString(),
                  "Err_108",
                  "无格口号"
                );
              }

              bIsDisplsy = true;
              LogHelper.WriteLog(
                "无格口号 " +
                  dwsQueryResponseNew.data.da_TOU_BI +
                  " " +
                  dwsQueryResponseNew.data.waybill_NO
              );
              dwsQueryResponseNew.data.lattice_NO = "153";
            } else {
              this.currentGeKou = dwsQueryResponseNew.data.lattice_NO;
            }

            // if (sw.ElapsedMilliseconds <= 400)
            if (dwsQueryResponseNew.endTime - dwsQueryResponseNew.startTime <= 400) {
              if (!bIsDisplsy) {
                this.errormessage =
                  "格口号：" + dwsQueryResponseNew.data.lattice_NO;
              }

              //给底层发格口信息
              // HKSocket.SynSendDataCallBack(SendDataType.PortData, dwsQueryResponseNew.data.WAYBILL_NO + "|" + dwsQueryResponseNew.data.LATTICE_NO);
              obj_DWS_Core.hKSocketSynSendDataCallBack(
                SendDataType.PortData,
                dwsQueryResponseNew.data.waybill_NO +
                  "|" +
                  dwsQueryResponseNew.data.lattice_NO
              );
            } else {
              dwsQueryResponseNew.data.lattice_NO = "0";
              // HKSocket.SynSendDataCallBack(SendDataType.PortData, dwsQueryResponseNew.data.WAYBILL_NO + "|" + dwsQueryResponseNew.data.LATTICE_NO);
              obj_DWS_Core.hKSocketSynSendDataCallBack(
                SendDataType.PortData,
                dwsQueryResponseNew.data.waybill_NO +
                  "|" +
                  dwsQueryResponseNew.data.lattice_NO
              );
              // LogHelper.WriteLog("三段码网关返回超时(默认400ms)：" + sw.ElapsedMilliseconds.ToString());
              LogHelper.WriteLog(
                "三段码网关返回超时(默认400ms)：" +
                  (dwsQueryResponseNew.endTime - dwsQueryResponseNew.startTime).toString()
              );
            }
          }

          if (this.m_bNeedSuppleCode) {
            if (
              this.m_strValidState == "1" ||
              (dwsQueryResponseNew.data.extend1 == "1" &&
                this.m_strValidState == "3")
            ) {
              setTimeout(() => {
                LogHelper.WriteLog(
                  "【揽发合一】需要补码，包裹准入code = " + codeCheckData.code
                );
                obj_DWS_Core.hKSocketSynSendDataCallBack(
                  SendDataType.SuppleCode,
                  codeCheckData.code
                );
                LogHelper.WriteLog(
                  "SendDataType.SuppleCode:" + codeCheckData.code
                );
                // HKSocket.SynSendDataCallBack(SendDataType.SuppleCode, codeCheckData.code);
                this.m_bNeedSuppleCode = false;
              }, 30);
              // // Thread.Sleep(100);
            } else {
              return false;
            }
          }

          let gotAllNecessaryDataFlag = true;
          this.stAcceptPacketReturnData.data.busiData.customerId = "";
          this.stAcceptPacketReturnData.data.busiData.customerName = "";
          this.stAcceptPacketReturnData.data.busiData.desOrgCode = "";
          this.stAcceptPacketReturnData.data.busiData.desOrgName = "";
          this.stAcceptPacketReturnData.data.busiData.employeeId = "";
          this.stAcceptPacketReturnData.data.busiData.employeeName = "";
          this.stAcceptPacketReturnData.data.busiData.daTouBi = "";
          LogHelper.WriteLog(
            "[揽发合一]清空寄件客户id和寄件客户名称，目的网点和名称，收派员和收派员名称，大头比"
          );

          if (this.m_strValidState == "1" || this.m_strValidState == "3") {
            this.stAcceptPacketReturnData.data.busiData.customerId =
              dwsQueryResponseNew.data.customer_NO;
            this.stAcceptPacketReturnData.data.busiData.customerName =
              dwsQueryResponseNew.data.extend2;

            //判断订单是否带目的网点
            let _str = this.inputModel.input_DestinationOrgNow;
            if (
              !this.IsNullorEmptyorUndefined(_str) &&
              _str.indexOf("|") != -1
            ) {
              let strs = _str.split("|");
              this.stAcceptPacketReturnData.data.busiData.desOrgCode = strs[0];
              this.stAcceptPacketReturnData.data.busiData.desOrgName = strs[1];
              LogHelper.WriteLog(
                "[揽发合一]界面目的网点有值," + strs[0] + "," + strs[1]
              );
            } else {
              if (
                this.IsNullorEmptyorUndefined(dwsQueryResponseNew.data.dest_ORG)
              ) {
                this.errormessage =
                  "界面目的网点为空，订单携带目的网点编号为空";
                LogHelper.WriteLog(
                  "[揽发合一]界面目的网点为空，订单携带目的网点编号为空"
                );
                gotAllNecessaryDataFlag = false;
              } else {
                this.stAcceptPacketReturnData.data.busiData.desOrgCode =
                  dwsQueryResponseNew.data.dest_ORG;
                this.stAcceptPacketReturnData.data.busiData.desOrgName =
                  dwsQueryResponseNew.data.dest_CENTER;
                LogHelper.WriteLog(
                  "[揽发合一]界面目的网点为空，订单携带目的网点编号有值," +
                    dwsQueryResponseNew.data.dest_ORG +
                    "," +
                    dwsQueryResponseNew.data.dest_CENTER
                );
              }
            }

            //判断订单是否带收派员
            let __str = this.inputModel.input_PersonNow;
            if (
              !this.IsNullorEmptyorUndefined(__str) &&
              __str.indexOf("|") != -1
            ) {
              let strs = __str.split("|");
              this.stAcceptPacketReturnData.data.busiData.employeeId = strs[0];
              this.stAcceptPacketReturnData.data.busiData.employeeName =
                strs[1];
              LogHelper.WriteLog("界面收派员有值," + strs[0] + "," + strs[1]);
            } else {
              if (
                this.IsNullorEmptyorUndefined(
                  dwsQueryResponseNew.data.employee_NO
                )
              ) {
                this.errormessage = "界面收派员为空，订单携带收派员为空";
                gotAllNecessaryDataFlag = false;
                LogHelper.WriteLog(
                  "[揽发合一]界面收派员为空，订单携带收派员为空"
                );
              } else {
                this.stAcceptPacketReturnData.data.busiData.employeeId =
                  dwsQueryResponseNew.data.employee_NO;
                this.stAcceptPacketReturnData.data.busiData.employeeName =
                  dwsQueryResponseNew.data.extend3;
                LogHelper.WriteLog(
                  "[揽发合一]界面收派员为空，订单携带收派员有值," +
                    dwsQueryResponseNew.data.employee_NO +
                    "," +
                    dwsQueryResponseNew.data.extend3
                );
              }
            }

            this.stAcceptPacketReturnData.data.busiData.daTouBi =
              dwsQueryResponseNew.data.da_TOU_BI;

            if (this.m_strValidState == "1" && gotAllNecessaryDataFlag) {
              LogHelper.WriteLog(
                "【揽发合一】业务网关取格口，通知海康让plc走and m_strValidState = " +
                  this.m_strValidState
              );
              // HKSocket.SynSendDataCallBack(SendDataType.CodeValid, this.m_strValidState);
              obj_DWS_Core.hKSocketSynSendDataCallBack(
                SendDataType.CodeValid,
                this.m_strValidState
              );
              return true;
            } else {
              LogHelper.WriteLog(
                "[揽发合一]通知海康停止,m_strValidState=" +
                  this.m_strValidState +
                  ",收派员和目的网点判断=" +
                  gotAllNecessaryDataFlag
              );
              return false;
            }
          } else {
            LogHelper.WriteLog(
              "[揽发合一]通知海康停止,m_strValidState=" + this.m_strValidState
            );
            return false;
          }
        }
      } catch (ex) {
        LogHelper.WriteLog("【揽发合一】调用三段码接口异常：" + ex);
      }
      return false;
    } catch (ex) {
      LogHelper.WriteLog("【揽发合一】调用三段码接口异常：" + ex);
      return false;
    }
  }
  //生成异常走件上传的请求
  private GetAbnormalMovingPartUploadRequest(
    code,
    strInfo,
    strWeight = null,
    DaTouBi = null
  ) {
    debugger;
    let _nextorgcode = "";
    if (this.inputModel.input_NextOrgNow.indexOf("|") != -1) {
      _nextorgcode = this.inputModel.input_NextOrgNow.split("|")[0];
    }
    let _request = {
      devMac: this.globalConfig.LocalMac,
      devType: this.globalConfig.CurrentDeviceType.toString(),
      body: {
        containerNo: null,
        effectiveTypeCode: null,
        frequencyNo: null,
        empCode: this.loginData.userCode,
        ioType: null /*dicIoType[cbx_recvType.Text]*/,
        nextOrgCode: _nextorgcode,
        opCode: "310", //异常件改成揽发类型
        orgCode: this.loginData.orgCode,
        createTime: dayjs().valueOf(),
        previousOrgCode: null /*tbx_previousWebPoint.Text*/,
        waybillNo: code,
        weight: strWeight == null || strWeight.length == 0 ? null : strWeight,
        deviceType: strInfo,
        errorCode: DaTouBi,
        extend1: "",
        extend2: "",
        extend3: "",
      },
    };

    return _request;
  }
  //异常走件上传，弃用 modify by klm 20220420
  private AbnormalMovingPartUpload(
    strCode,
    strInfo,
    strIoTypeName = null,
    exceptionCode = null
  ) {
    try {
      var request = this.GetAbnormalMovingPartUploadRequest(
        strCode,
        strInfo,
        strIoTypeName,
        exceptionCode
      );
      let responseStr = abnormalMovingPartDataUpload(JSON.stringify(request));
      let response = JSON.parse(responseStr);
      if (!response.isSuccess) {
        LogHelper.WriteLog("异常走件上传失败" + response.respMessage);
      } else {
        LogHelper.WriteLog("异常走件上传成功" + response.respMessage);
      }
    } catch (ex) {
      LogHelper.WriteLog("异常走件方法调用异常" + ex);
    }
  }

  //新异常走件方法 add by klm 20220420
  private NewAbnormalMovingPartUpload(
    strCode,
    strInfo,
    strIoTypeName = null,
    exceptionCode = null
  ) {
    try {
      let datetimeNow = dayjs().format("YYYY-MM-DD HH:mm:ss.SSS");
      let signsure = obj_HttpRequest_Core.getSignature("8606", datetimeNow);

      let _request = {
        mty: "8606",
        signature: signsure, //登录时需要获取的签名
        createTime: datetimeNow,
        waybillNo: strCode,
        containerNo: null, //容器号,非必填
        deviceType: this.globalConfig.CurrentDeviceType.toString(), //设备类型，必填
        deviceNo: this.globalConfig.LocalIPv4, //大写,用冒号分隔，必填
        errorCode: exceptionCode, //异常码，必填
        errorMsg: strInfo, //异常信息，必填
        opCode: "310", //操作码，非必填
        ioType: null, //收发类型，非必填
        nextOrgCode: "", //下一网点，非必填
        weight: "", //重量，非必填
        createUserCode: this.loginData.userCode,
        extend1: "",
        extend2: "",
        extend3: "",
      };
      let stReturnStr = JSON.parse(cloudPress(JSON.stringify(_request)));
      if (stReturnStr?.code == "000") {
        LogHelper.WriteLog("新异常走件方法上传成功");
      } else {
        LogHelper.WriteLog(
          "新异常走件上传失败,返回异常码：" +
            stReturnStr?.code +
            "异常信息：" +
            stReturnStr?.msg
        );
      }
    } catch (ex) {}
  }

  //判断条码
  private NativeCheck(id) {
    let _flag = this.LinePreFixRuleCheck(id);
    if (!_flag) {
      let temps = [];
      temps.push(id);
      var rgStr = checkCodesAndType(temps, "", "");
      var rg = JSON.parse(rgStr);
      if (rg != null && rg.ResultCode == "200") {
        return true;
      } else {
        return false;
      }
    }
    return _flag;
  }
  //线路更新
  public panel_line_ValueChanged(id, content) {
    //label_scanReturnError.Text = "";
    try {
      if (this.IsNullorEmptyorUndefined(id)) {
        return;
      }
      let bReturnState = true;

      let stCodeCheckInput = {
        devMac: this.globalConfig.LocalMac,
        devType: "0",
        body: {
          queryValue: id.toUpperCase(),
          queryType: "0",
          viewType: "1",
          extend1: "",
          extend2: "",
          extend3: "",
        },
      };
      let stReturnData: any = {};

      let strReturn = "";
      if (!this.NativeCheck(id)) {
        //label_scanReturnError.Text = "输入号码非法";
        //panel_line.Text = panel_line.OldText;
        return;
      }

      //先本地
      stReturnData = JSON.parse(checkCode(JSON.stringify(stCodeCheckInput)));

      //label_scanReturnError.Text = stReturnData.respMessage;
      this.errormessage = stReturnData.respMessage;

      //tbx_scanArea.Focus();
      //tbx_scanArea.SelectAll();

      if (stReturnData.respcode != "000") {
        bReturnState = false;

        //label_scanReturnError.Text = stReturnData.respMessage;
        this.errormessage = stReturnData.respMessage;
        if (stReturnData.respMessage == "") {
          //label_scanReturnError.Text = "服务器掉线";
          this.errormessage = "服务器掉线";
        }

        //panel_line.Text = panel_line.OldText;
      } else {
        if (stReturnData.data.queryNoType == ApiQueryType.strCarCode) {
        } else if (
          stReturnData.data.queryNoType == ApiQueryType.strTimeValidCode
        ) {
        } else if (
          stReturnData.data.queryNoType == ApiQueryType.strStationCode
        ) {
        } else if (stReturnData.data.queryNoType == ApiQueryType.strLineCode) {
          debugger;
          this.errormessage = stReturnData.respMessage;
          let job = {
            devMac: "00-00-00-00-00-00",
            devType: "0",
            body: {
              queryValue: id, //过滤字符串
              queryType: "21",
              viewType: "1",
              extend1: "", //当前页
              extend2: "", //页大小
              extend3: "", //过滤字段
            },
          };
          var result = getOrgCodeListByPage(JSON.stringify(job));
          if (result != null) {
            try {
              //List<OrgModel> list = new List<OrgModel>();
              let objectModels = [];
              let _list = [];

              let _data = JSON.parse(result);
              let jArray = _data.data.busiDataArray;
              debugger;
              jArray.forEach((v) => {
                debugger;
                objectModels.push({
                  label: v.endOrgCode,
                  value: v.endOrgName,
                });
                _list.push({
                  label: v.endOrgName,
                  value: v.endOrgCode,
                });
              });
              this.options_NextOrg = _list;
            } catch (error) {
              LogHelper.Error(error);
            }
          }

          stCodeCheckInput.body.queryType = "1";
          if (this.options_NextOrg.length > 0) {
            this.inputModel.input_NextOrgNow =
              this.options_NextOrg[this.options_NextOrg.length - 1].value +
              "|" +
              this.options_NextOrg[this.options_NextOrg.length - 1].label;
            this.inputModel.input_NextOrg =
              this.options_NextOrg[this.options_NextOrg.length - 1].label;
          } else {
            this.inputModel.input_NextOrgNow = "";
            this.inputModel.input_NextOrg = "";
          }

          this.GetLineInfo(stReturnData.data.queryNo);

        }
      }

      if (bReturnState) {
        //tbx_scanArea.Clear();
        this.inputModel.input_scancode = "";
      }

      //tbx_scanArea.Focus();
      //tbx_scanArea.SelectAll();
    } catch (ex) {
      LogHelper.WriteLog("选择线路：" + ex);
    }
  } //字符串为null、空、未定义判断
  private IsNullorEmptyorUndefined(data) {
    if (data == null || data == undefined || data == "") {
      return true;
    } else {
      return false;
    }
  }
  //线路查询
  private LinePreFixRuleCheck(scanContent: string) {
    let _flag = false;
    var rulesStr = obj_GlobalData_Core.getLineCodePreFixRules();
    if (rulesStr != null && rulesStr.length > 0) {
      var rules = JSON.parse(rulesStr);
      rules.forEach((element) => {
        console.log(element); //可遍历到所有数组元素
        if (scanContent.startsWith(element)) {
          _flag = true;
        }
      });
    } else {
      this.linePrefixRuleIds.forEach((element) => {
        console.log(element); //可遍历到所有数组元素
        if (scanContent.startsWith(element)) {
          _flag = true;
        }
      });
    }
    return _flag;
  }
  // 重新聚焦到文本框
  public selectElementContents(el) {
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }

  //下一网点选择
  private chooseNextOrgCode(item): void {
    this.inputModel.input_NextOrgNow = item.value + "|" + item.label;
  }

  //下一网点界面更新判定
  private getNextOrgCallback(datas) {
    debugger;
    this.inputModel.input_NextOrgNow =
      datas.nextOrgCode + "|" + datas.nextOrgName;
    var jsonobj = JSON.parse(datas.result);
    if (jsonobj.data.busiDataArray != null) {
      this.options_NextOrg = [];
      jsonobj.data.busiDataArray.forEach((element) => {
        this.options_NextOrg.push({
          label: element.endOrgName,
          value: element.endOrgCode,
        });
      });
      this.inputModel.input_NextOrg = this.options_NextOrg[0].value;
    }
  }

  //删除历史记录
  private deleterowdata() {
    if (this.currentRow == null) {
      this.messageboxShow("warning", "请先选择要删除的数据");
      return;
    }

    this.$confirm("是否确定要删除此数据？", "删除", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        console.log("执行删除以下数据的动作");
        console.log(this.currentRow);
        try {
          this.Deletedatahistory(this.currentRow);
        } catch (error) {
          console.log("删除失败：" + error.message);
        }
        this.currentRow = null;
      })
      .catch(() => {
        console.log("取消删除");
      });
  }
  //删除历史记录实现
  private Deletedatahistory(currentRow) {
    if (currentRow == null) {
      return;
    }
    LogHelper.WriteLog(
      "揽发合一:执行删除动作：车签：" +
        currentRow.carlabel +
        "，条码为：" +
        currentRow.scancode
    );
    debugger;
    let package_Data = currentRow;
    if (null == package_Data) {
      LogHelper.WriteLog("揽发合一:没有找到要删除的记录");
      return;
    }
    if (package_Data?.state == "未上传") {
      this.errormessage = "未上传，不能删除";
      return;
    }
    let takingTruckUploadRequest = {
      devMac: this.globalConfig.LocalMac, //物理地址中间的分隔符需要为“-”
      devType: this.globalConfig.CurrentDeviceType.toString(),
      body: {
        mac: this.globalConfig.LocalMac,
        aviType: 0,
        trace: 0,
        isFirstTransfer: 1,
        mty: "0240", //默认为0240 与上下车不同
        opRecord: {
          auxOpCode: "DELETE",
          auxRouteCode: "0",
          containerNo: package_Data?.carlabel,
          createOrgCode: this.loginData.orgCode,
          createTerminal: this.globalConfig.LocalIPv4,
          createTime: package_Data.createTime,
          createUserCode: this.loginData.userCode,
          createUserName: this.loginData.userName,
          desOrgCode: package_Data?.strDestOrgCode,
          deviceType: "CV-PC", //默认
          expType: 10,
          expressContentCode: "PKG", //默认为包裹
          feeAmt: "0.0",
          feeFlag: 0,
          frequencyNo: "", //无频次
          inputWeight: package_Data?.PutinWeight,
          ioType: "01", //收发类型 正常
          waybillNo: package_Data.code,
          modifyOrgCode: this.loginData.orgCode,
          modifyTerminal: "",
          modifyTime: package_Data.modifyTime,
          modifyUserCode: "",
          modifyUserName: "",
          nextOrgCode: package_Data.NextOrgCode,
          opCode: "310131", //默认
          orgCode: this.loginData.orgCode,
          uploadTime: package_Data.uploadTime,
          transportTypeCode: "1",
          transferStatus: 0,
          remark: "10020007", //，默认
          sourceOrgCode: this.loginData.orgCode,
          weighWeight: package_Data.weight,
          pkgWidth: package_Data.width,
          pkgLength: package_Data.length,
          pkgHeight: package_Data.height,
          volumeWeight: package_Data.VolumnWeight.toString(),
          pkgQty: 1,
          lineNo: package_Data.LineCode,
          previousOrgCode: "",
          routeCode: "",
          customData: {
            takingEffectiveTime: "C005", //72小时
            takingEmployeeCode: package_Data.strEmployeeId,
            employeeName: package_Data.strEmployeeName,
            takingCustomerCode: package_Data.strCustomerId,
            customerName: package_Data.strCustomerName,
            frequency: "", //以下默认
            inOutDiff: "1",
            lineFrequencyNo: "",
            otFlag: 0,
            refId: "",
            returnPart: "",
            vehiclePlateNo: "",
            opStation: this.globalConfig.CompName,
            extend1: "",
            extend2: "",
            extend3: "",
          },
        },
      },
    };
    var response = JSON.parse(
      takingTruckUpload(JSON.stringify(takingTruckUploadRequest))
    );
    if (response.respcode != "000") {
      this.errormessage = response.respMessage;
      // // LogHelper.WriteLog("揽发合一:执行删除动作异常，接口code返回"+response.respcode+"：车签："+this.inputModel.carlabel+"，条码为："+this.inputModel.scancode+",页面剩余：{dataHistoryOnForms.Count()}条数据，后台剩余：{DataHistory.Count()}条数据");
      LogHelper.WriteLog(
        "揽发合一:执行删除动作异常，接口code返回" + response.respcode
      );
    } else {
      // // dataHistoryOnForms.Remove(dataHistoryOnForm);
      // // QueueAcceptPacketAndGetOnEntity queueAcceptPacketAndGetOnEntity = DataHistory.Where(obj => obj.CarSignNum == _dynamic["carlabel"] && obj.code == _dynamic["scancode"]).FirstOrDefault();
      // // DataHistory.Remove(queueAcceptPacketAndGetOnEntity);

      let dataHistoryOnForm = this.showList.filter(
        (obj) =>
          obj.index == package_Data.index && obj.code == package_Data.code
      )[0];
      debugger;
      this.nTotalScanNum--;
      if (this.nTotalScanNum < 0) {
        this.nTotalScanNum = 0;
      }
      this.PackageNumInCar--;
      if (this.PackageNumInCar < 0) {
        this.PackageNumInCar = 0;
      }
      this.dWholeWeight -=
        null == dataHistoryOnForm
          ? 0.0
          : Number.parseFloat(dataHistoryOnForm.weight);
      if (this.dWholeWeight < 0) {
        this.dWholeWeight = 0;
      }
      this.statisticalList[0].value = this.nTotalScanNum.toString();
      this.statisticalList[1].value = this.PackageNumInCar.toString();
      this.statisticalList[2].value = this.dWholeWeight.toString();

      this.showList = this.showList.filter(
        (obj) =>
          !(obj.index == package_Data.index && obj.code == package_Data.code)
      );

      LogHelper.WriteLog("揽发合一:执行删除动作结束");
      this.errormessage = "删除成功";
    }
  }

  //前端未使用，暂时保留
  private errormsgshowcallback(msg) {
    this.$message.error(msg);
  }
  //前端未使用,暂时保留
  private successmsgshowcallback(msg) {
    this.$message.success(msg);
  }
}
